<template>
  <div class="place-rating-card one-component-detail-admin">
    <div class="title-component-admin">
      <el-row type="flex" align="middle" justify="space-between">
        <div>
          <span>Rating ({{ total }})</span>
          <el-button
            type="primary"
            size="small"
            title="Làm mới"
            icon="el-icon-refresh-right"
            class="ml-2"
            :disabled="loading"
            @click="handleReloadData"
          >Làm mới</el-button>
        </div>
        <div>
          <el-button
            type="primary"
            size="small"
            title="Thêm mới Rating"
            icon="el-icon-circle-plus-outline"
            :disabled="loading"
            @click="handleOpenPopup(null)"
          >Thêm</el-button>
        </div>
      </el-row>
    </div>

    <el-table v-loading="loading" :data="ratings">
      <el-table-column label="STT" type="index" width="50" align="center"></el-table-column>
      <el-table-column label="Nguồn" width="130" align="center">
        <template slot-scope="scope">
          <el-tag :type="getOriginTagType(scope.row.origin)" size="small">
            <i :class="getOriginIcon(scope.row.origin)" class="mr-1"></i>
            {{ getOriginLabel(scope.row.origin) }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column label="Đánh giá" width="160" align="center">
        <template slot-scope="scope">
          <el-rate
            v-if="scope.row.origin === 'google' || scope.row.origin === 'gg'"
            v-model="scope.row.rating"
            disabled
            allow-half
            show-score
            text-color="#ff9900"
            score-template="{value}"
          ></el-rate>
          <span v-else class="font-weight-bold text-primary">{{ scope.row.rating }} / 10</span>
        </template>
      </el-table-column>

      <el-table-column label="Số Reviews" width="120" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.extra_data && scope.row.extra_data.helpful_votes !== undefined">
            👍 {{ scope.row.extra_data.helpful_votes }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="Link gốc" min-width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <a v-if="scope.row.source_url" :href="scope.row.source_url" target="_blank" class="source-link">
            <i class="fas fa-external-link-alt mr-1"></i> {{ scope.row.source_url }}
          </a>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <!-- <el-table-column label="Ngày đánh giá" width="130" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.rated_at || '-' }}</span>
        </template>
      </el-table-column> -->

      <el-table-column label="Thao tác" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <el-tooltip content="Chỉnh sửa" placement="top">
            <el-button icon="el-icon-edit" type="primary" circle size="small" @click="handleOpenPopup(scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip content="Xóa" placement="top">
            <el-button icon="el-icon-delete" circle type="danger" size="small" @click="handleDeleteRating(scope.row)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <el-row type="flex" align="middle" justify="end" class="my-3 pr-2">
      <el-pagination
        :current-page.sync="page"
        :page-size.sync="limit"
        :total="total"
        background
        layout="total, prev, pager, next"
        @current-change="handleChangePage"
      ></el-pagination>
    </el-row>

    <update-rating-popup
      v-if="formVisible"
      :visible="formVisible"
      :rating-item="selectedRating"
      :object="data"
      @close="formVisible = false"
      @reload="getRatings"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { listPlaceRatings, deletePlaceRating } from '@/services/place-rating'
import UpdateRatingPopup from '@/views/place-rating/components/popup/Update.vue'

export default {
  name: 'RatingCard',
  components: {
    UpdateRatingPopup
  },
  props: {
    data: Object,
    type: String
  },
  data() {
    return {
      loading: true,
      ratings: [],
      formVisible: false,
      selectedRating: null,
      limit: 10,
      total: 0,
      page: 1
    }
  },
  computed: {
    ...mapGetters(['language']),
    params() {
      return {
        locale: this.language,
        place_id: this.data ? this.data.id : '',
        page: this.page,
        per_page: this.limit
      }
    }
  },
  watch: {
    'data.id': {
      handler(newId) {
        if (newId) {
          this.getRatings()
        }
      },
      immediate: true
    }
  },
  methods: {
    getRatings() {
      if (!this.data || !this.data.id) return
      this.loading = true
      listPlaceRatings(this.params).then((response) => {
        const result = (response && response.result) || (Array.isArray(response) ? response : [])
        this.ratings = result
        this.total = (response && response.total) !== undefined ? response.total : this.ratings.length
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },

    handleOpenPopup(item) {
      this.selectedRating = item || null
      this.formVisible = true
    },

    handleDeleteRating(item) {
      this.$confirm('Bạn có chắc chắn muốn xóa đánh giá này không?', 'Xác nhận', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.loading = true
        deletePlaceRating({ id: item.id }).then(() => {
          this.$notify.success({
            title: 'Thành công',
            message: 'Xóa đánh giá thành công'
          })
          this.getRatings()
        }).catch((err) => {
          this.loading = false
          this.$notify.error({
            title: 'Lỗi',
            message: (err && err.response && err.response.data && err.response.data.message) || 'Không thể xóa!'
          })
        })
      }).catch(() => {})
    },

    handleChangePage(page) {
      this.page = page
      this.getRatings()
    },

    handleReloadData() {
      this.page = 1
      this.getRatings()
    },

    getOriginTagType(origin) {
      if (origin === 'google') return 'primary'
      if (origin === 'booking') return 'success'
      if (origin === 'council') return 'warning'
      return 'info'
    },
    getOriginIcon(origin) {
      if (origin === 'google') return 'fab fa-google'
      if (origin === 'booking') return 'fas fa-hotel'
      if (origin === 'council') return 'fas fa-award'
      return 'fas fa-star'
    },
    getOriginLabel(origin) {
      if (origin === 'google') return 'Google'
      if (origin === 'booking') return 'Booking'
      if (origin === 'council') return 'Hội đồng'
      return origin || 'N/A'
    }
  }
}
</script>

<style lang="scss" scoped>
.place-rating-card {
  .source-link {
    color: #409EFF;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
